import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { getRestaurantSystemId, setRestaurantSystemId } from "@/api/lib/url";
import { logo } from "@/assets";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardHeader,
  CardContent,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { Store, ArrowRight, ShieldCheck, ExternalLink } from "lucide-react";
import toast from "react-hot-toast";

function Redirect() {
  const navigate = useNavigate();
  const [manualId, setManualId] = useState("");
  const savedId = getRestaurantSystemId();

  useEffect(() => {
    if (savedId) {
      const token = localStorage.getItem("token");
      if (token) {
        navigate("/home", { replace: true });
      } else {
        navigate(`/${savedId}`, { replace: true });
      }
    }
  }, [savedId, navigate]);

  if (savedId) {
    return null;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = manualId.trim();
    if (!trimmed) {
      toast.error("Please enter a valid Restaurant System ID");
      return;
    }

    setRestaurantSystemId(trimmed);
    navigate(`/${trimmed}`);
  };

  return (
    <div className="bg-black min-h-screen w-screen flex items-center justify-center p-4">
      <Card className="bg-cblack2/90 border border-white/10 max-w-md w-full shadow-2xl backdrop-blur-md">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <img className="h-10 object-contain" src={logo} alt="Amaanah POS" />
          </div>
          <div className="mx-auto w-12 h-12 rounded-2xl bg-cyellow/10 text-cyellow flex items-center justify-center mb-2">
            <Store className="w-6 h-6" />
          </div>
          <CardTitle className="text-xl font-bold text-cwhite">Connect Restaurant</CardTitle>
          <CardDescription className="text-gray-400 text-xs mt-1">
            Enter your Restaurant System ID or follow the direct link provided for your restaurant branch.
          </CardDescription>
        </CardHeader>
        <CardContent className="pt-4">
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-gray-300">
                Restaurant System ID
              </label>
              <input
                type="text"
                value={manualId}
                onChange={(e) => setManualId(e.target.value)}
                placeholder="e.g. 48de05f0-737c-449d-af02-6e23ab67be52"
                className="w-full px-3.5 py-2.5 rounded-xl bg-cblack7 border border-white/10 text-cwhite placeholder:text-gray-500 text-sm focus:outline-none focus:border-cyellow/60 transition-colors"
                autoFocus
              />
            </div>
            <Button
              type="submit"
              className="bg-cyellow text-slate-950 font-bold hover:bg-yellow-400 w-full rounded-xl py-2.5 mt-2 flex items-center justify-center gap-2 cursor-pointer transition-all active:scale-95"
            >
              <span>Continue to POS</span>
              <ArrowRight className="w-4 h-4" />
            </Button>
          </form>

          <div className="mt-6 pt-4 border-t border-white/5 flex items-center justify-between text-xs text-gray-400">
            <span>Admin or store manager?</span>
            <a
              href="https://client.amaanahsoft.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-cyellow hover:underline flex items-center gap-1 font-medium"
            >
              <span>Client Panel Login</span>
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default Redirect;